/**
 * Toggle company fields on checked checkbox
 * ======================================
 * - jquery needed
 */
import $ from "jquery";

$("#company_checkbox").on("change", function() {
  $(".js-woocommerce-company-field").toggleClass("form-row-hidden");
});
